// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';
import { Airspace } from './Airspace';

export class Volume implements IVolume {
    prisms!: VolumePrism[];

    constructor(data?: IVolume) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prisms"])) {
                this.prisms = [] as any;
                for (let item of _data["prisms"])
                    this.prisms!.push(VolumePrism.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Volume {
        data = typeof data === 'object' ? data : {};
        let result = new Volume();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prisms)) {
            data["prisms"] = [];
            for (let item of this.prisms)
                data["prisms"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IVolume {
    prisms: VolumePrism[];
}